module.exports = __webpack_public_path__ + "img/csr7.9fa6403e.jpg";